import { render, staticRenderFns } from "./icon-person.vue?vue&type=template&id=3795f066&scoped=true&"
import script from "./icon-person.vue?vue&type=script&lang=js&"
export * from "./icon-person.vue?vue&type=script&lang=js&"
import style0 from "./icon-person.vue?vue&type=style&index=0&id=3795f066&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3795f066",
  null
  
)

export default component.exports